import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import css from '../css/notification-icon.m.css';

interface NotificationIconProperties {
	isSpeedDialNotification?: boolean;
}

const factory = create({ theme }).properties<NotificationIconProperties>();

export const NotificationIcon = factory(({ properties, middleware: { theme } }) => {
	const themeCss = theme.classes(css);
	const { isSpeedDialNotification = false } = properties();

	return v(
		'div',
		{
			classes: [isSpeedDialNotification ? themeCss.speedDialNotificationIcon : themeCss.menuItemNotificationIcon],
			xqa: 'has-menu-item-notification'
		},
		[
			v('span', { classes: ['fa-stack'] }, [
				// v('i', { classes: ['fas', 'fa-circle', 'fa-stack-1x', themeCss.notificationBackground] }),
				v('i', { classes: ['fa-stack-1x', 'fas', 'fa-star', themeCss.notificationForeground] })
			])
		]
	);
});
